var restorepassword = {
    restore: "RESTORE PASSWORD",
    eyebrowLabel: "Secure password update",
    text1: "Enter your new password",
    text2: "Create a strong password to regain access to your account.",
    panelTitle: "Choose a new password",
    panelText: "Use at least 8 characters and make sure both fields match before saving the change.",
    login: "Login",
    newpass: "New Password:",
    renewpass: "Repeat Password:",
    newpassPlaceholder: "Enter your new password",
    renewpassPlaceholder: "Confirm your new password",
    sendbtn: "Save",
    saving: "Saving...",
    error: "error: confirm password must be equal",
    msg: "Your password has been changed, go Login to get access again",
    loginbtn: "Login",
    errorpage: "ERROR PAGE",
    errortext1: "You must use the correct process to restore password",
    errorgo: "please, go back to home",
    errorbtn: "Welcome/Home",
    requiredNewPassword: "New password is required.",
    requiredRepeatPassword: "Please confirm your new password.",
    passwordMinLength: "Your password must be at least 8 characters long.",
    passwordMismatch: "Passwords do not match.",
    successTitle: "Password updated",
    successText: "Your password was changed successfully. You can now sign in again with your new password.",
    successHelp: "For security, please use your new password the next time you log in.",
    invalidLinkTitle: "This password reset link is not valid",
    invalidLinkText: "You need to follow the correct password reset process before creating a new password.",
    invalidLinkHelp: "Go back to the home page or request a new password reset link from the forgot password screen.",
    message_error_pass_1:"an error has been detected while request password change, try later",  
    success_password_changed:"Your password has been changed, go Login to get access again"  
}
module.exports = restorepassword
